<template>
  <div class="container-confirm">
    <van-dialog v-model="showDiaUp" :showConfirmButton="false" :closeOnClickOverlay="true" @close="close">
      <div class="dialog">
        <!-- <div class="headline">{{ headline }}</div> -->
        <div class="title">{{ title }}</div>
        <div class="btn">
          <div class="two">
            <span @click="handleThinK" class="confirm-think">
              {{ $t('lang.BaseCommon.k006') }}
            </span>
            <span @click="handleConfirm" class="confirm-btn">
              {{ $t('lang.OtherModule.k025') }}
            </span>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    showDiaUp: {
      type: Boolean,
      default: false,
    },
    title: {},
    // headline: {},
    oneShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    handleGot() {
      // this.$parent.confirmAgain()
      this.close()
    },
    handleThinK() {
      this.$parent.upCancel()
    },
    handleConfirm() {
      this.$parent.confirmUp()
    },
    close() {
      this.$parent.cancelAgain()
    },
  },
  watch: {},
  computed: {},
}
</script>
<style lang="scss" scoped>
.container-confirm {
  .dialog {
    width: 300px;
    height: 172px;
    background: #ffffff;
    border-radius: 12px;
    padding: 25px 20px 0 20px;
    margin: 0 auto;
    .headline {
      width: 100%;
      text-align: center;
      color: #000;
      font-weight: 600;
    }
    .title {
      // width: 260px;
      height: 40px;
      font-size: 16px;
      font-family: 'Inter-Medium', 'Inter-Regular';
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      text-align: center;
      margin: 10px 0;
    }
    .one {
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      margin: 20px auto 0;
      background: #a338fc;
      border-radius: 20px;
      font-size: 16px;
      font-family: 'Inter-Bold', 'Inter-Regular';
      font-weight: 600;
      color: #ffffff;
    }
    .two {
      display: flex;
      align-items: center;
      justify-content: space-around;
      > span {
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin: 10px auto 0;
        background: #a338fc;
        border-radius: 20px;
        font-size: 16px;
        font-family: 'Inter-Bold', 'Inter-Regular';
        font-weight: 600;
        color: #ffffff;
      }
      .confirm-think {
        background-color: #e1e1e1;
      }
    }
  }
}
</style>
